import { Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild } from "@angular/core";
import { DatePipe } from "@angular/common";
import { FormControl } from "@angular/forms";
import * as _ from "lodash";
import { Combo2Service, ExcelService, ReportService } from "../../../services/index";
import { SalesOrderService } from "../../../services/salesOrder.service";

@Component({
  selector: "sales-Plan-MasterReport",
  templateUrl: "./specialDisc.html"
})
export class specialDiscParties implements OnInit {
  @Input("tabTitle") title: string;
  @Input("tabID") tabID: string;
  @Input() active = false;
  @Input() dataContext;
  @Output() tabUpdateEvent = new EventEmitter();
  @ViewChild("snoTemplate") snoTemplate: TemplateRef<any>;

  finyearCtrl: FormControl = new FormControl();
  seasonCtrl: FormControl = new FormControl();
  typeCtrl: FormControl = new FormControl();
  orderCtrl: FormControl = new FormControl();
  isLoadMask: Promise<any>;

  loadingIndicator: boolean;
  gridOptions: any;
  seasonList = [];
  seasonyearList = [];
  colorList = [];
  orderList = [];
  menu: any;
  seasonfinList = [];
  backbutton: boolean;
  showIncharger: string;
  showAgent: string;
  showLine: string;
  typeList = [];
  exceldata: any;
  ord_date_change: boolean = false;
  totalseason_target: string;
  seasonShow: string;
  date_id: any;
  year_id: any;
  filter = {
    fin_id: "",
    season: "",
    annual_season_id: "",
    season_id: "",
    groupby: "INCHARGER",
    finyear: "",
    from_date: "",
    to_date: "",
    ord_from_date: "",
    ord_to_date: "",
    incharger_name: "",
    agent_name: "",

  };

  columns = [];
  toggleCol = [];
  finyearList: any;

  constructor(
    private salesPlan: SalesOrderService,
    private combo2Service: Combo2Service,
    private reportService: ReportService,
    public datePipe: DatePipe,
    private excelService: ExcelService
  ) {

    this.colorList = ["lightcyan", "bisque", "lightblue", "lightgoldenrodyellow", "thistle", "floralwhite", "#cc97ca", "#f2cd75", "#cec4aa", "lightblue"];
    this.typeList = ["LINE", "AGENT", "PARTY"];
    this.orderList = ["ORDERED", "NON-ORDERED", "BOTH"];
    this.backbutton = false;
    this.loadingIndicator = true;
  }

  ngOnInit(): void {

    this.columns = [];
    this.finyearCombo();
    this.loadSeasonList();

    this.gridOptions = {
      columns: this.columns,
      loading: true,
      data: []
    };

    this.toggleCol = Object.assign({}, this.columns);
  }

  finyearCombo() {
    this.combo2Service.finyearCombo().then((res: any) => {
      this.finyearList = res.data;
      this.finyearCtrl.setValue(res.data[0].fin_id);
      this.year_id = res.data[0].fin_id;
    });


  }
  onSelectFinyear(id) {
    this.year_id = id;
    let seasonfinList = _.filter(this.seasonList, { fin_id: id });
    this.seasonfinList = seasonfinList;
    this.seasonCtrl.setValue(
      this.seasonList[this.seasonList["length"] - 1].season_id
    );
    this.onSelectdate('ALL');

    console.log(this.date_id);
  }
  displayFinyear(comboType: string, id: number) {

    let list: any = [];
    if (comboType == "Finyear") {
      list = this.finyearList;
    }

    if (id && list.length > 0) {
      let fitem = _.find(list, { fin_id: id });
      return fitem["finyear"];
    }
    return "";
  }

  displayFn(comboType: string, id: number) {
    this.date_id = id;
    console.log(this.date_id);
    let list: any = [];
    let that = this;
    list = that.seasonList;

    if (id && list.length > 0) {
      let fitem = _.find(list, { season_id: id });
      this.seasonShow = fitem["season"];
      return fitem["season"];
    }
    return "";
  }
  loadSeasonList() {
    let that = this;
    that.reportService.getBrandNewSeason(this.filter).then(function (res) {
      that.seasonList = res;
      that.seasonyearList = res;
      that.onSelectdate('ALL');
      that.allseason();
      that.seasonCtrl.setValue(res[res["length"] - 1].season_id);
      that.salesPlanMasterReport();
    });
  }

  allseason() {
    let fin_id = parseInt(this.filter.fin_id);

    this.seasonList.forEach(() => {
      let seasonAll = {
        season: "ALL",
        season_id: this.seasonList[this.seasonList["length"] - 1].season_id + 1,
        fin_id: fin_id,
        // order_from : this.seasonList[0].order_from,
        // order_to : this.seasonList[this.seasonList["length"] - 1].order_to,
        // sales_from : this.seasonList[0].sales_from,
        // sales_to : this.seasonList[this.seasonList["length"] - 1].sales_to,
      };
      if (fin_id > 0) {
        this.seasonList.push(seasonAll);
      }
      fin_id = fin_id - 1;
    });


  }



  onSelectdate(type) {
    if (type == "ALL") {

      let id = this.year_id;
      let data = this.seasonyearList;
      let obj_data = data.filter(o => o.fin_id == id);

      let obj = obj_data.filter(o => o.season !== type);
      this.filter.from_date = obj[0].sales_from;
      this.filter.to_date = obj[obj["length"] - 1].sales_to;
      this.filter.ord_from_date = obj[0].order_from;
      this.filter.ord_to_date = obj[obj["length"] - 1].order_to;
    }
    else if (type !== "ALL") {

      let fest_id = this.date_id;
      let data = this.seasonyearList;
      let obj = data.find(o => o.season_id === fest_id);

      this.filter.from_date = obj.sales_from;
      this.filter.to_date = obj.sales_to;
      this.filter.ord_from_date = obj.order_from;
      this.filter.ord_to_date = obj.order_to;



    }
  }
  applyFilter(): void {

 

     

    this.salesPlanMasterReport();
  }
  onCellClick(event) {
  
    let row = event.row;
    this.backbutton = false;
   
    if (this.filter.groupby == "AGENT") {
      this.filter.agent_name = row.agent_name;
      this.filter.groupby = "PARTY";
    }
    if (this.filter.groupby == "INCHARGER") {
     
      this.filter.incharger_name = row.inch;
      this.filter.groupby = "AGENT";
    
    }


    this.salesPlanMasterReport();
  }
  onbackbutton(groupby) {
 
    if (groupby == "PARTY") {
      this.backbutton = true;
      this.filter.groupby = "AGENT";
      this.filter.agent_name = "";
    }
    if (groupby == "AGENT") {
      this.backbutton = false;
      this.filter.groupby = "INCHARGER";
      this.filter.incharger_name = "";
    }
    this.salesPlanMasterReport();
  }
  salesPlanMasterReport(): void {
    this.filter.from_date = this.datePipe.transform(
      this.filter.from_date,
      "yyyy-MM-dd"
    );
    this.filter.to_date = this.datePipe.transform(
      this.filter.to_date,
      "yyyy-MM-dd"
    );
    if (this.ord_date_change) {
      this.filter.ord_from_date = this.filter.from_date;
      this.filter.ord_to_date = this.filter.to_date;
      this.ord_date_change = false;

    }
    this.filter.ord_from_date = this.datePipe.transform(
      this.filter.ord_from_date,
      "yyyy-MM-dd"
    );
    this.filter.ord_to_date = this.datePipe.transform(
      this.filter.ord_to_date,
      "yyyy-MM-dd"
    );

    let params = {
      filter: JSON.stringify(this.filter)
    };
    let that = this;
    that.gridOptions = {
      loading: true,
      columns: [],
      data: []
    };

    this.isLoadMask = this.salesPlan
      .specialPartiesList(params)
      .then(function (res: any) {
     
        that.gridOptions = {
          columns: res.columns,
          data: res.data,
          loading: false
        };

        that.exceldata = that.getData(res.columns, res.data);
      });
      
  }
  exportToExcel($event) {
    this.excelService.exportAsExcelFile(this.exceldata, this.title);
  }

  addDate(){
     this.ord_date_change = true;
  }
  getData(columns, data) {
    let cols = columns;
    let rows = [],
      row,
      clen = columns.length;

    for (let i = 0; i < data.length; i++) {
      let sno = i + 1;
      row = Object.assign({}, data[i]);
      let newrow = {
        Sno: sno
      };
      for (let j = 1; j < clen; j++) {
        let prop = cols[j].prop,
          name = cols[j].name;

        newrow[name] = row[prop];
      }

      rows.push(newrow);
      sno++;
    }
    return rows;
  }

  ngOnDestroy() {
    this.salesPlan;
  }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/Sales/specialDisCustomer/specialDisc.ts